import { createClient } from "@hey-api/client-fetch";
import { defineAsyncComponent, createApp } from "vue";
import { createPinia } from "pinia";

import { i18n } from "@/app/i18n";
import { router, routerPush } from "@/app/router";
import { LoginController } from "@/app/actions/login";

console.info(`App.js: ${__NAME__} ${__VERSION__}`);

const App = defineAsyncComponent(() => import("@/app/App.vue"));

routerPush("objects");

const app = createApp(App);
const element = document.querySelector("#app") as HTMLElement;

export const client = createClient({
    baseUrl: element.dataset["api"],
});

const pinia = createPinia();

app.provide("baseurl.file", element.dataset["file"]);
app.provide("baseurl.api", element.dataset["api"]);
app.use(router);
app.use(pinia);
app.use(i18n);
app.mount(element);

LoginController.init();

console.info(`App.js: API BaseURL: ${element.dataset["api"]}`);
